var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useState } from 'react';
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import { MapManagerProvider } from '../../context/map-manager-context';
import LatLonPicker from './mapPicker';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var MapPointPicker = function (_a) {
    var onPointCapture = _a.onPointCapture, mapDetails = _a.mapDetails, _b = _a.multiple, multiple = _b === void 0 ? false : _b, _c = _a.buttonLabel, buttonLabel = _c === void 0 ? 'Capture Point on Map' : _c;
    var _d = useState(false), showMap = _d[0], setShowMap = _d[1];
    var onSelectBT = function (points) {
        var sanitizedPoints = points.map(function (obj) { return ({
            latV: "" + obj.latV,
            latH: obj.latH,
            longV: "" + obj.longV,
            longH: obj.longH,
        }); });
        if (multiple) {
            onPointCapture('CaptureBT', sanitizedPoints);
        }
        else {
            onPointCapture('CaptureBT', sanitizedPoints === null || sanitizedPoints === void 0 ? void 0 : sanitizedPoints[0]);
        }
        handleMapClose();
    };
    var handleMapClose = function () {
        setShowMap(false);
    };
    var handleMapOpen = function () {
        setShowMap(true);
    };
    return (React.createElement(Container, null,
        React.createElement(Button, { variant: "contained", color: "primary", onClick: handleMapOpen }, buttonLabel),
        React.createElement(MapManagerProvider, { value: mapDetails },
            React.createElement(LatLonPicker, { multiple: multiple, buttonId: 'id', open: showMap, onPointConfirm: onSelectBT, handleClose: handleMapClose }))));
};
export default MapPointPicker;
var templateObject_1;
//# sourceMappingURL=index.js.map